var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.loadNobrandQrcode ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showNobrandQrcode,
      expression: "showNobrandQrcode"
    }],
    staticClass: "Layer-FullScreen noticeType-Bulletbox component-nobrand-qrcode",
    class: {
      'show-animation': _vm.showNobrandQrcode,
      'fade-out': _vm.showOutAnimation
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.hideBox.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "main",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "QR-code"
  }), _c('p', {
    staticClass: "txt-p"
  }, [_vm._v("长按二维码即可保存/分享")]), _c('ycf-image', {
    staticClass: "close-btn",
    attrs: {
      "src": "/srcv2/images/close_QRcode_box_icon.png"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.hideBox.apply(null, arguments);
      }
    }
  })], 1)]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };